import React, { PureComponent } from 'react';

class TablaHeader extends PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        const { tieneScroll } = this.props;

        return <thead>
            <tr>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderTipoMov'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>TIPO MOV.</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderFechaValor'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>FECHA VALOR</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderFechaImputacion'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>FECHA IMPUTACIÓN</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderMotivo'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>MOTIVO</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderDebitoCredito'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>D/C</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderCuotas'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>CUOTAS</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderImporteTotal'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>IMP. TOTAL</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderEstado'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>ESTADO</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderAcciones'>
                    <div className={"ingresoAjustesTableHeaderInsideDiv"}>ACCIONES</div>
                </div>
                <div className='ingresoAjustesTableHeader ingresoAjustesTableHeaderDropDownBtn'>
                    {/* Espacio para botón desplegable */}
                </div>
            </tr>
        </thead>
    }
}

export default TablaHeader;